import Vue from "vue";
import Vuex from "vuex";
import Auth from "./modules/Auth";
import User from "./modules/User";
import Plans from "./modules/Plans";
import Products from "./modules/Products";
import Roles from "./modules/Roles";
import Organizations from "./modules/Organizations";
import Groups from "./modules/Groups";
import Invitations from "./modules/Invitations";
import Projects from "./modules/Projects";
import Dashboard from "./modules/Dashboard";
import Helpers from "./modules/Helpers";
import Loader from "./modules/Loader";
import UserFiles from "./modules/UserFiles";
import UserFilesCustomLuts from "./modules/UserFilesCustomLuts";
import UI from "./modules/UI";
import App from "./modules/App";
import Comments from "@/store/modules/Comments";
import Notifications from "@/store/modules/Notifications";
import Files from "@/store/modules/Files";
import Scopes from "@/store/modules/Scopes";
import Downloadables from "@/store/modules/Downloadables";

Vue.use(Vuex);

export default new Vuex.Store({
	state: {
		loading: false,
	},
	modules: {
		Auth,
		User,
		Plans,
		Products,
		Roles,
		Organizations,
		Groups,
		Invitations,
		Projects,
		Dashboard,
		Helpers,
		Loader,
		UserFiles,
		UserFilesCustomLuts,
		UI,
		Scopes,
		App,
		Comments,
		Notifications,
		Files,
		Downloadables
	},
	strict: process.env.NODE_ENV !== "production",
	actions: {
		resetAll: ({ dispatch }) => {
			dispatch("Auth/resetState");
			dispatch("Dashboard/resetState");
			dispatch("Groups/resetState");
			dispatch("Invitations/resetState");
			dispatch("Organizations/resetState");
			dispatch("Plans/resetState");
			dispatch("Projects/resetState");
			dispatch("Roles/resetState");
			dispatch("User/resetState");
			dispatch("UserFiles/resetState");
			dispatch("Loader/resetState");
			dispatch("UI/resetState");
			dispatch("Scopes/resetState");
			dispatch("App/resetState");
			dispatch('Comments/resetState');
			dispatch('Notifications/resetState');
		},
		resetData: ({ dispatch }) => {
			dispatch("Dashboard/resetState");
			dispatch("Groups/resetState");
			dispatch("Invitations/resetState");
			dispatch("Organizations/resetState");
			dispatch("Plans/resetState");
			dispatch("Projects/resetState");
			dispatch("Roles/resetState");
			dispatch("User/resetState");
			dispatch("UserFiles/resetState");
			dispatch("Loader/resetState");
			dispatch("UI/resetState");
			dispatch("Scopes/resetState");
			dispatch("App/resetState");
			dispatch('Comments/resetState');
			dispatch('Notifications/resetState');
		},
		resetApp: ({ dispatch }) => {
			dispatch("Projects/resetState");
			dispatch("UserFiles/resetState");
			dispatch("Loader/resetState");
			dispatch("UI/resetState");
			dispatch("Scopes/resetState");
			dispatch("App/resetState");
			dispatch('Comments/resetState');
			dispatch('Notifications/resetState');
		},
	},
});
